export const NAME = 'compliance'

export default {
  NAME
}
